export class ApiResponseModel {
    data?: any | null = null;
    count?: number = 0;
    isSuccess?: boolean = false;
    message?: string = "";
    // statusCode: number;
}